import { If } from "@/components/custom/condition";
import { Loader2 } from "lucide-react";
import { CSSProperties, ReactNode } from "react";

interface IProps {
  type?: "button" | "submit" | "reset";
  outline?: boolean;
  className?: string;
  children?: ReactNode;
  loading?: boolean;
  disabled?: boolean;
  onClick?: (event) => void;
  style?: CSSProperties;
  id?: string;
  sizeLoading?: "small" | "medium" | "large";
}

export function BaseButton(props: IProps) {
  const {
    type = "button",
    outline = false,
    className,
    children,
    loading = false,
    disabled = false,
    onClick = () => {},
    sizeLoading = "medium",
    ...prop
  } = props;

  return (
    <button
      type={type}
      disabled={disabled}
      className={`flex items-center justify-center rounded-md min-w-[88px] px-4  text-base whitespace-nowrap font-bold text-center !outline-0  ${
        outline ? " border-2" : ""
      } ${
        disabled
          ? "disabled:bg-gray_400 disabled:text-white disabled:border-gray_400"
          : outline
          ? "bg-white text-main border-main"
          : "bg-main  text-white"
      } ${className}`}
      style={{
        cursor: loading || disabled ? "not-allowed" : "pointer",
      }}
      onClick={(e) => {
        !loading && onClick(e);
      }}
      {...prop}
    >
      {children}
      <If
        condition={loading}
        Then={
          <span className="typography-h5 ml-2">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          </span>
        }
      />
    </button>
  );
}
